import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
};

const IconTimePast: React.FC<Props> = ({
  width = 20,
  height = 20,
  color = '#3E454D',
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.6251 6.66667V9.7408L12.1085 11.2242C12.3527 11.4683 12.3527 11.8642 12.1085 12.1084C11.9868 12.23 11.8268 12.2917 11.6668 12.2917C11.5068 12.2917 11.3468 12.2309 11.2251 12.1084L9.55844 10.4417C9.44094 10.3242 9.37513 10.165 9.37513 10V6.66667C9.37513 6.32167 9.65513 6.04167 10.0001 6.04167C10.3451 6.04167 10.6251 6.32167 10.6251 6.66667ZM10.0217 1.875C7.67919 1.875 5.48429 2.88662 3.95846 4.61995V2.5C3.95846 2.155 3.67846 1.875 3.33346 1.875C2.98846 1.875 2.70846 2.155 2.70846 2.5V5.83333C2.70846 6.17833 2.98846 6.45833 3.33346 6.45833H6.66679C7.01179 6.45833 7.29179 6.17833 7.29179 5.83333C7.29179 5.48833 7.01179 5.20833 6.66679 5.20833H5.12769C6.40436 3.8925 8.15521 3.125 10.0227 3.125C13.801 3.125 16.8759 6.20917 16.8759 10C16.8759 13.7908 13.8019 16.875 10.0227 16.875C7.39771 16.875 5.04935 15.4124 3.89519 13.0583C3.74269 12.7491 3.37089 12.6191 3.05839 12.7724C2.74839 12.9241 2.6209 13.2984 2.77173 13.6084C4.1384 16.3942 6.91586 18.125 10.0217 18.125C14.4892 18.125 18.1251 14.48 18.1251 10C18.1251 5.52 14.49 1.875 10.0217 1.875Z"
      fill={color}
    />
  </svg>
);

export default IconTimePast;
